import React, { memo } from 'react';
import type { FC } from 'react';
import { BrowserRouter } from 'react-router-dom';
import s from './index.module.scss';
import './scrollbar.css';
import { Router as PageFromRouter } from './router';

const ConnectedApp: FC = memo(() => {
  return (
    <div className={s.app}>
      <PageFromRouter />
    </div>
  );
});

export const App: FC = () => {
  return (
    <BrowserRouter>
      <ConnectedApp />
    </BrowserRouter>
  );
};
